import React from "react";
import {Helmet} from "react-helmet-async";

const ForvaltningPage = () => (
    <>
        <Helmet>
            <title>Förvaltning</title>
        </Helmet>
        <div>
            <h1>Förvaltning</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default ForvaltningPage;
